import React from "react";
import { Card, Flex, Icon } from "@telia/teddy";
import { SellingPoints, trackingContext } from "../../../../../../models";
import "./PromoCardList.less";
import { trackUIClickEvent } from "../../../../google-analytics/googleAnalyticsEventHelper";

interface PromoCardListProps {
    sellingPoints?: SellingPoints[];
    trackingContext?: trackingContext;
}

const PromoCardList: React.FC<PromoCardListProps> = ({ sellingPoints, trackingContext }) => {
    return (
        <Flex gap="200">
            {sellingPoints?.map((point) => {
                // TODO(dark-mode): review, CMS-selected primitive color token on a purple-dark card; keep unless CMS moves to semantic tokens
                const textColorStyle = point.textColor ? { color: `var(--teddy-color-${point.textColor})` } : undefined;
                return (
                    <Card
                        key={point.heading}
                        layout="product"
                        variant="purple-dark"
                        backgroundImageSrc={point.backgroundImage?.url}
                        imageGradient={point.backgroundImageGradient || "none"}
                        className="usp-list__promo-card"
                    >
                        <Card.Heading className="promo-card-list__cta-card-heading" style={textColorStyle}>
                            {point.heading}
                        </Card.Heading>
                        {point.content && (
                            <Card.Content className="promo-card-list__cta-card-content" style={textColorStyle}>
                                <div dangerouslySetInnerHTML={{ __html: point.content }} />
                            </Card.Content>
                        )}
                        {point.url && (
                            <Card.Footer>
                                <Card.Button
                                    variant="primary"
                                    aria-label="Navigate"
                                    iconOnly={!point.buttonLabel}
                                    asChild
                                    onClick={async () => {
                                        if (trackingContext && point?.url) {
                                            await trackUIClickEvent({
                                                action: "click",
                                                context: `${trackingContext.prefix}_navigation_card`,
                                                text: point.heading,
                                                type: "link",
                                                url: trackingContext.url,
                                            });
                                        }
                                    }}
                                >
                                    <a href={point.url}>
                                        {point.buttonLabel ? (
                                            point.buttonLabel
                                        ) : (
                                            <Icon name="arrow-right" aria-hidden="true" focusable="false" />
                                        )}
                                    </a>
                                </Card.Button>
                            </Card.Footer>
                        )}
                    </Card>
                );
            })}
        </Flex>
    );
};

export default PromoCardList;
